import Vue from 'vue';
import VueI18n from 'vue-i18n'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue';
import locale from 'element-ui/lib/locale'
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'

Vue.config.productionTip = false
Vue.use(VueI18n);
Vue.use(ElementUI,{enLocale});

const messages = {
  'zh-CN': {
    ...zhLocale,
    // 自定义中文语言
  },
  'en-US': {
    ...enLocale,
    // 自定义英文语言
  }
};

var i18n = new VueI18n({
  locale:"en-US",
  messages,
})
locale.i18n((key, value) => i18n.t(key, value));
new Vue({
	i18n,
	render: h => h(App),
}).$mount('#app')
